<template>
  <div
    class="job-architecture-treeview d-flex flex-column align-start justify-start"
    :style="containerStyle"
  >
    <JobArchitectureTreeviewItem
      v-for="rootItem in items"
      :key="rootItem[itemValue]"
      :item="rootItem"
      :depth="0"
      :item-value="itemValue"
      :item-title="itemTitle"
      :item-children="itemChildren"
      :selected="selected"
      :selectable="selectable"
      :level-has-children="levelHasChildren"
      @update:selected="$emit('update:selected', $event)"
    >
      <template #item-label="{ item: slotItem }">
        <slot
          name="item-label"
          :item="slotItem"
        />
      </template>
    </JobArchitectureTreeviewItem>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

const JobArchitectureTreeviewItem = defineAsyncComponent(
  () => import('@/components/shared/JobArchitectureTreeviewItem.vue'),
);

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  itemValue: {
    type: String,
    default: 'value',
  },
  itemTitle: {
    type: String,
    default: 'title',
  },
  itemChildren: {
    type: String,
    default: 'children',
  },
  selectable: {
    type: Boolean,
    default: true,
  },
  selected: {
    type: Array,
    default: () => [],
  },
  maxHeight: {
    type: Number,
    default: undefined,
  },
});

defineEmits(['update:selected']);

const levelHasChildren = computed(() => props.items.some((item) => {
  const children = item[props.itemChildren];

  return Array.isArray(children) && children.length > 0;
}));

const containerStyle = computed(() => (props.maxHeight != null ? { maxHeight: `${props.maxHeight}px` } : {}));
</script>

<style scoped lang="less">
@import '@/less/mixins';

.job-architecture-treeview {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}
</style>
